<template>
  <header class="header">
    <div class="header__inner">
      <div class="header__logos">
        <div><img src="../assets/img/logos/sber.svg" alt="Сбер"></div>
        <div><img src="../assets/img/logos/marathon.svg" alt="Зеленый марафон"></div>
        <div><img src="../assets/img/logos/vklad.svg" alt="Вклад в будущее" width="90px"></div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader',
}
</script>
